import { lazy } from "react";

export { BPM_ROLES_MAIN_PATH } from "./bpm-roles-main-path";
export const BpmRolesMainPage = lazy(() => import("./bpm-roles-main"));
